import { Component, EventEmitter, Input, Output } from '@angular/core';

export enum ModalHeaderTheme {
  WHITE,
  GREY,
}

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss']
})
export class ModalHeaderComponent {
  @Input() title: string = '';
  @Input() centerTitle = false;
  @Input() showCloseButton = false;
  @Input() theme: ModalHeaderTheme = ModalHeaderTheme.GREY;

  @Output() closed = new EventEmitter<Event>();

  modalHeaderTheme = ModalHeaderTheme;

  constructor() {}

  onCloseModalClicked(event: Event) {
    this.closed.emit(event);
  }

  getTheme() {
    const themePrefix = 'theme';
    let bgThemeClass = '';

    switch (this.theme) {
      case ModalHeaderTheme.WHITE:
        bgThemeClass = 'white';
        break;
      case ModalHeaderTheme.GREY:
        bgThemeClass = 'grey';
        break;
    }

    return `${themePrefix}-${bgThemeClass}`;
  }
}
